import {gsap} from "../LibrariesImport";

export default class FollowCursor {
	static init() {
		const follow = document.querySelector(".follow-cursor");
		const items = document.querySelectorAll(".follow-cursor-container");

		items.forEach(container => {

			container.addEventListener("mouseenter", e => {
				container.appendChild(follow);
				let containerOffset = container.getBoundingClientRect();
				const followRect = follow.getBoundingClientRect();
				const x = e.clientX - containerOffset.left;
				const y = e.clientY - containerOffset.top;

				gsap.set(follow, {
					x: x - followRect.width / 2,
					y: y - followRect.height / 2,
					rotationX: "45deg",
					rotationY: "45deg"
				});

				if (window.innerWidth > 420) {
					gsap.to(follow, {
						opacity: 1,
						rotationX: "0deg",
						rotationY: "0deg",
						scale: 1,
						duration: 0.3
					});
				}
			});

			container.addEventListener("mouseleave", () => {
				gsap.to(follow, {
					opacity: 0,
					scale: 0.2,
					rotationX: "45deg",
					rotationY: "45deg",
					duration: 0.3
				});
			});

			container.addEventListener("mousemove", e => {
				let containerOffset = container.getBoundingClientRect();
				const followRect = follow.getBoundingClientRect();

				// Déplace instantanément le cercle à l'endroit ou entre le curseur et l'affiche
				const x = e.clientX - containerOffset.left;
				const y = e.clientY - containerOffset.top;
				gsap.to(follow, 0.3, {
					x: x - followRect.width / 2,
					y: y - followRect.height / 2,
				});
			});
		});
	}
}
